import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const COPY = defineMessages({
  AVAILABLE: {
    id: 'Pricing.copy.Available',
    defaultMessage: 'available',
    desc: {
      id: 'Pricing.copy.Available',
      message: '[Type: label][Vis: high] - Pricing details comparison feature cell value',
      project: PROJECT_NAME,
    },
  },
  UNAVAILABLE: {
    id: 'Pricing.copy.Unavailable',
    defaultMessage: 'unavailable',
    desc: {
      id: 'Pricing.copy.Unavailable',
      message: '[Type: label][Vis: high] - Pricing details comparison feature cell value',
      project: PROJECT_NAME,
    },
  },
  BUSINESS_PLANS_LINK: {
    id: 'Pricing.copy.BusinessPlansLink',
    defaultMessage: 'Included with business plans',
    desc: {
      id: 'Pricing.copy.BusinessPlansLink',
      message: '[Type: link][Vis: high] - Link to pricing teams details page',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
